import { useState } from 'react';
import './SubModal.css';
import * as Yup from 'yup';
import Form from '../../../components/form/components/Form/Form';
import FormField from '../../../components/form/components/FormField/FormField';
import Button from '../../../components/form/components/Button/Button';
import ErrorMessage from '../../../components/form/components/ErrorMessage/ErrorMessage';
import { ImCancelCircle } from 'react-icons/im';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import moment from 'moment';
import { auth } from '../../../firebase/firebase-config';
import { doc, collection,query, where, getDocs,setDoc, addDoc, getDoc, updateDoc, serverTimestamp, arrayUnion   } from "firebase/firestore"; 

import { Timestamp } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { db } from "../../../firebase/firebase-config";

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const initialValues= {
  plan_name: null,
  plan_name_fr: null,
  price:  null,
}

const override = {
    marginTop: '20px'
};


function ReadingsModal({ onClose, onContentAdded, activeCaseData } : any) {
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);

    const [user] = useAuthState(auth);
    const [gender, setGender] = useState('');

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Phone is required'),
        name_french: Yup.string().required('Phone is required'),
        price: Yup.number().required("Price Is Required"),
    })

    let [description, setDescription ] = useState('');
    let [descriptionFr, setDescriptionFr ] = useState('');

    const [isEnabled, setIsEnabled] = useState("Yes")

    // NEW VALS

    const calculateDateForMonths = (startDate: any, months: any) => {
      // Split the start date into year, month, and day components
      const [startYear, startMonth, startDay] = startDate.split('-');
      
      // Create a new Date object using the start date components
      const startDateObject = new Date(startYear, startMonth - 1, startDay);
      
      // Calculate the target date by adding the specified number of months
      const targetDate = new Date(startDateObject.getFullYear(), startDateObject.getMonth() + months, startDateObject.getDate());
      
      // Format the target date as YYYY-MM-DD
      const formattedDate: any = targetDate.toISOString().split('T')[0];

      return new Date(formattedDate);
    };

    const handleSubmitData = async (values: any) => {


            try {

            // console.log('VALS:  ',  testData);

            // return;

            setLoading(true);

            let reqData = {
              name: values?.name,
              name_french: values?.name_french,
              description: description,
              description_french: descriptionFr,
              enabled: isEnabled == 'Yes' ? true : false,
              price:  Number(values?.price),
            };

            const plansRef = collection(db, "Features");

            await addDoc(plansRef, reqData);

            setLoading(false);
            onContentAdded();

            toast.success("Feature created successfully", {
              pauseOnHover: false,
              closeOnClick: true,
            });

            } catch (error) {
              setLoading(false);

              toast.error("Error Creating Error", {
                pauseOnHover: false,
                closeOnClick: true,
              });
            }
    }



    return (
        <div>
            <div  className='modal-container student-modal-assignment' id="plans-modal">
                <div className='modal-head'>
                    <p className="modal-title">Feature Data</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onClose} size={22} color="#fff"/>
                </div>
                <div className='modal-content'>
                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                    <BeatLoader
                        color="#3080ED" 
                        loading={loading}
                        cssOverride={override}
                    />
                </div>
                <form action="" className="auth-form">

                {error && <ErrorMessage error={error} visible={true} />}
                <Form 
                    initialValues={initialValues}
                    onSubmit={handleSubmitData}
                    validationSchema={validationSchema}
                >
    
                <p className="label-text">Feature's Name: </p>
                  <FormField  name="name" type="text" placeholder="Enter Plan's Name"/>
                <br />
                <p className="label-text">Feature's Name French: </p>
                  <FormField  name="name_french" type="text" placeholder="Enter Plan's Name"/>
                <br />
                <p className="label-text">Description: </p>
                <textarea rows={4} onChange={(e: any) => setDescription(e.target.value)} value={description} className="textarea"></textarea>
                <br />
                <br />
                <p className="label-text">Description French: </p>
                <textarea rows={4} onChange={(e: any) => setDescriptionFr(e.target.value)} value={descriptionFr} className="textarea"></textarea>
                <br />
                <br />
                <p className="label-text">Enabled: </p>
                <select
                      style={{ borderRadius: 5, padding: 10, height: "50px" }}
                      onChange={(e: any) => {
                        setIsEnabled(e.target.value);
                      }}
                      value={isEnabled}
                      className="select-field-modal"
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                  </select>
                    <br  />

                <p className="label-text">Price: </p>
                  <FormField name="price" type="number" placeholder="Price" />
                <br />
          
                <br />
                      {!loading && <Button isOutLined={true} isFullWidth={false} title="SUBMIT DATA"/>}

                    </Form>
                </form>
                </div>
            </div>
            <div className="modal-shadow" onClick={onClose}>
               
            </div>
        </div>
    );
}

export default ReadingsModal;



